import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirm-signup',
  templateUrl: './confirm-signup.component.html',
  styleUrls: ['./confirm-signup.component.css']
})
export class ConfirmSignupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmSignupComponent>) { }

  onOkClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
